angular.module('components.caImportEditorSummary', [])
    .component('caImportEditorSummary', {
        templateUrl: 'main/product/productimporteditor/components/importeditorsummary.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            importFile: '=',
            updateSummary: '<'
        },
        controller: controller
    });

// @ngInject
function controller($scope) {
    var vm = this;

    //Properties
    vm.showSummaries = true;
    vm.summaries = [];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    function onInit() {
        $scope.$watch(function() { return vm.updateSummary; }, function() {
            recalculateSummaries();
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

    function recalculateSummaries() {
        if (vm.importFile && vm.importFile.importRows && vm.importFile.importRows.length > 0) {
            vm.summaries = [];
            var orders = _.groupBy(vm.importFile.importRows, function(row) { return row.orderNumberExternal + row.companyCode + row.locationCode + row.plannedDeliveryDate; });
            if (Object.keys(orders).length > 0 && vm.importFile.importType.toLowerCase() === "order") {
                vm.summaries.push({ title: 'common.orders', count: Object.keys(orders).length });
            }
            var products = _.groupBy(vm.importFile.importRows, function(row) { return row.alternativeArticleNumber; });
            if (Object.keys(products).length > 0) {
                vm.summaries.push({ title: 'common.articles', count: Object.keys(products).length });
            }
            var productVariants = _.groupBy(vm.importFile.importRows, function(row) { return row.barcode; });
            if (Object.keys(productVariants).length > 0) {
                vm.summaries.push({ title: 'common.articlevariants', count: Object.keys(productVariants).length });
            }
            var variant1s = _.groupBy(vm.importFile.importRows, function(row) { return row.variant1Name; });
            if (Object.keys(variant1s).length > 0) {
                vm.summaries.push({ title: 'common.variant1s', count: Object.keys(variant1s).length });
            }
            var variant2s = _.groupBy(vm.importFile.importRows, function(row) { return row.variant2Name; });
            if (Object.keys(variant2s).length > 0) {
                vm.summaries.push({ title: 'common.variant2s', count: Object.keys(variant2s).length });
            }
        }
    }
}
